import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import {BioentitySummary} from 'folder-items/FileConstants';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {restArrayToGraphQL} from 'graphql-client/declarative-translations/external/translate';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import * as ModelActions from 'redux-stores/ModelActions';
import {getStore} from 'redux-stores/Store';

export default class BioentityModelManager extends ModelManager<ManagedModelType.BIOENTITY_SUMMARY> {
  constructor() {
    super(ManagedModelType.BIOENTITY_SUMMARY);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    const result = await FileBrowserDAO.bulkFetchFileSummaries(keys, false);
    const fileSummariesById = result?.fileSummariesById;
    // Deleted files and files that we have insufficient privilege to see are simply not included
    const inaccessibleFileIds = keys.filter((key) => !fileSummariesById![key]);
    getStore().dispatch(ModelActions.filesFetchCompleted(fileSummariesById!, inaccessibleFileIds));
    writeFragmentsToCache(
      getFragmentWrapper('BioentitySummary'),
      restArrayToGraphQL('BioentitySummary', Object.values(fileSummariesById!))
    );
  }

  getModel(modelKey: string): BioentitySummary | null {
    return getStore().getState().models.fileSummariesById[modelKey] || null;
  }

  isModelInaccessible(modelKey: string): boolean {
    return getStore().getState().models.inaccessibleFileIds.includes(modelKey);
  }
}
